import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import { getCurrentInstance, ref, onMounted, onUnmounted, useSlots, computed, nextTick } from 'vue';
import validation from '@/slango-multiverse/helpers/validations';
export default {
  __name: 's-infotooltip',
  props: {
    modelValue: {},
    message: {
      type: String
    },
    open: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'right'
    },
    // top, bottom, left, right | top-start, top-end ...
    floating: Boolean,
    offset: {
      type: Number,
      default: 6
    },
    validation: Object
  },
  setup(__props) {
    const {
      appContext
    } = getCurrentInstance();
    const gp = appContext.config.globalProperties;
    const slots = useSlots();
    const props = __props;
    const propsCopy = {
      ...props
    };
    const validationStatus = ref({});
    const isBackgroundLight = ref(false);
    const componentId = Math.floor(Math.random() * 9000) + 1000;
    const validate = () => {
      if (!props.validation) return true;
      if (props.validation.validate) {
        validationStatus.value = props.validation.validate();
        validationStatus.value.hasError = !validationStatus.value.valid;
        nextTick(scrollToFirstError);
        return validationStatus.value.valid;
      }
      validationStatus.value = validation.check(computedProps.value.modelValue, props.validation.subtype ?? props.validation.type);
      const {
        empty,
        valid
      } = validationStatus.value;
      validationStatus.value.hasError = props.validation.required && empty || props.validation.format && !empty && !valid;
      nextTick(scrollToFirstError);
      return !validationStatus.value.hasError;
    };
    const computedProps = computed(() => {
      const content = slots.default?.();
      return content?.[0]?.props;
    });
    const scrollToFirstError = () => {
      if (!validationStatus.value.hasError) return;
      if (!gp.$OnValidationAutoScroll) {
        gp.$OnValidationAutoScroll = true;
        document.querySelector('.slot-infotooltip-element')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        setTimeout(() => gp.$OnValidationAutoScroll = false, 1000);
      }
    };
    onUnmounted(() => {
      if (props.validation) {
        let {
          key,
          group
        } = props.validation;
        if (!key) key = componentId;
        const inputs = gp.$registeredInputs;
        if (inputs[group]) delete inputs[group][key];
        delete inputs.all[key];
      }
    });
    onMounted(() => {
      isBackgroundLight.value = gp.$backgroundLight(gp.$el);
      if (props.validation) {
        let {
          key,
          group,
          oneforall = true
        } = props.validation;
        if (!key) key = componentId;
        const config = {
          validate,
          showError: msg => validationStatus.value = {
            hasError: true,
            msg
          }
        };
        if (group) {
          if (!gp.$registeredInputs[group]) gp.$registeredInputs[group] = {};
          gp.$registeredInputs[group][key] = config;
        }
        if (oneforall) gp.$registeredInputs.all[key] = config;
      }
    });
    return (_ctx, _cache) => {
      const _component_s_infotooltip_element = _resolveComponent("s-infotooltip-element");
      const _component_s_floating = _resolveComponent("s-floating");
      return props.floating ? (_openBlock(), _createBlock(_component_s_floating, {
        key: 0,
        open: props.open,
        offset: props.offset,
        position: propsCopy.position,
        "onUpdate:position": _cache[0] || (_cache[0] = $event => propsCopy.position = $event)
      }, _createSlots({
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 2
      }, [validationStatus.value.hasError ? {
        name: "floating",
        fn: _withCtx(() => [_createVNode(_component_s_infotooltip_element, {
          message: validationStatus.value.msg ?? props.message,
          position: propsCopy.position
        }, null, 8, ["message", "position"])]),
        key: "0"
      } : undefined]), 1032, ["open", "offset", "position"])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["flex flex-col gap-1", {
          'slot-infotooltip-element': validationStatus.value.hasError
        }])
      }, [_renderSlot(_ctx.$slots, "default"), validationStatus.value.hasError ? (_openBlock(), _createBlock(_component_s_infotooltip_element, {
        key: 0,
        message: validationStatus.value.msg ?? props.message
      }, null, 8, ["message"])) : _createCommentVNode("", true)], 2));
    };
  }
};